import { Instagram, Facebook, MapPin, Phone, Mail } from "lucide-react";
import { useSmoothScroll } from "@/hooks/useSmoothScroll";
import WebPImage from "@/components/common/WebPImage";

const Footer = () => {
  const { scrollToElement } = useSmoothScroll();
  const handleScrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    scrollToElement(id, { offset: 80 });
  };
  const mapLink = "https://maps.app.goo.gl/3E44u662EVFfs5y57?g_st=com.google.maps.preview.copy";
  const instagramLink = "https://www.instagram.com/061garagedetailingstudio?igsh=MTZud2lxYWkybmtqcQ%3D%3D&utm_source=qr";
  const facebookLink = "https://www.facebook.com/share/18rLAmAdqC/?mibextid=wwXIfr";

  return (
    <footer className="bg-black relative">
      <div className="section-divider absolute top-0 left-0 right-0" />
      <div className="container mx-auto px-6 py-14">
        <div className="grid md:grid-cols-3 gap-10 mb-10">
          {/* Logo and Description */}
          <div className="md:col-span-1">
            <WebPImage
              src="/lovable-uploads/f4bfdea7-3faa-40df-abe5-c9950a51fcce.png" 
              srcSet="/lovable-uploads/f4bfdea7-3faa-40df-abe5-c9950a51fcce.png?w=64 64w, /lovable-uploads/f4bfdea7-3faa-40df-abe5-c9950a51fcce.png?w=128 128w"
              sizes="64px"
              alt="061 Garage Logo" 
              className="h-16 w-auto mb-4"
              width="64"
              height="64"
            />
            <p className="text-white/40 text-sm leading-relaxed mb-6">
              061 Garage Detailing Studio. Profesjonalna pielęgnacja pojazdów w Poznaniu. Oferujemy usługi mycia samochodów zewnątrz, detailingu wnętrz, prania tapicerki samochodowej, meblowej i dywanów.
            </p>
            
            <div className="flex space-x-3">
              <a href={instagramLink} target="_blank" rel="noopener noreferrer" className="icon-container-premium w-11 h-11 rounded-full flex items-center justify-center hover:bg-garage-blue/20 transition-all duration-300" aria-label="Odwiedź nasz profil na Instagramie">
                <Instagram className="h-4 w-4 text-white/60" aria-hidden="true" />
              </a>
              <a href={facebookLink} target="_blank" rel="noopener noreferrer" className="icon-container-premium w-11 h-11 rounded-full flex items-center justify-center hover:bg-garage-blue/20 transition-all duration-300" aria-label="Odwiedź nasz profil na Facebooku">
                <Facebook className="h-4 w-4 text-white/60" aria-hidden="true" />
              </a>
            </div>
          </div>
          
          {/* Spacer */}
          <div className="hidden md:block" />
          
          {/* Contact Info */}
          <div className="md:col-span-1">
            <h3 className="font-display text-white font-semibold mb-5 text-sm tracking-wider uppercase">Kontakt</h3>
            <div className="space-y-4">
              <a href="tel:602709327" className="flex items-center text-white/40 hover:text-garage-blue transition-colors text-sm link-underline">
                <Phone className="h-4 w-4 mr-3 text-white/20" />
                602 709 327
              </a>
              <a href="mailto:061garageds@gmail.com" className="flex items-center text-white/40 hover:text-garage-blue transition-colors text-sm link-underline">
                <Mail className="h-4 w-4 mr-3 text-white/20" />
                061garageds@gmail.com
              </a>
              <a href={mapLink} target="_blank" rel="noopener noreferrer" className="flex items-center text-white/40 hover:text-garage-blue transition-colors text-sm link-underline">
                <MapPin className="h-4 w-4 mr-3 text-white/20" />
                ul. Bluszczowa, Poznań
              </a>
            </div>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="border-t border-white/5 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-white/30 text-xs">
              © {new Date().getFullYear()} 061 Garage Detailing Studio. Wszelkie prawa zastrzeżone.
            </p>
            
            <div className="flex flex-wrap justify-center md:justify-end gap-6 text-xs">
              <a href="/regulamin" className="text-white/30 hover:text-garage-blue transition-colors link-underline">Regulamin</a>
              <a href="/regulamin#privacy-policy" className="text-white/30 hover:text-garage-blue transition-colors link-underline">Polityka prywatności</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
